<template>
  <div>
    <!-- Filter Start -->
    <custom-filter :getFilterOnStart="true" @filterChange="changeFilter"></custom-filter>
    <!-- Filter End -->

    <!-- Table Start -->
    <div class="innerBox mt-4">
      <div class="row">
        <div class="col-md-8">
          <h5 class="elegant--sub-title">
            Consumer Report
            <i class="far fa-info-circle" id="history-report"></i>
            <b-popover target="history-report" triggers="hover" placement="top">
              <template #title>Consumer Report</template>
              <div v-html="tooltip.consumer_report"></div>
            </b-popover>
          </h5>
        </div>
      </div>
      <!-- <div class="row">
                <div class="col-md-10">
                    <h5 class="elegant--sub-title">History Report</h5>
                </div>
                <div class="col-md-2">
                    <button class="btn btn-elegant-download">Download Excel <i class="fas fa-download"></i></button>
                </div>
            </div> -->
      <div class="mt-3 scan-history-table-wrapper">
        <!-- Loading State -->
        <div v-if="tableLoading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>

        <!-- Table -->
        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>QR Code</th>
                <th>Variant</th>
                <th>Volume</th>
                <th>Reason</th>
                <th>Description</th>
                <th>Latitude</th>
                <th>Longitude</th>
                <th>Scan Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in tableData" :key="`${currentPage}-${index}`">
                <td>{{ row.url || 'N/A' }}</td>
                <td>{{ row.variant || 'N/A' }}</td>
                <td>{{ row.volume || 'N/A' }}</td>
                <td>{{ truncateText(row.reason, 40) }}</td>
                <td>{{ truncateText(row.description, 20) || 'N/A' }}</td>
                <td>{{ row.lat || 'N/A' }}</td>
                <td>{{ row.lng || 'N/A' }}</td>
                <td>{{ formatScanDate(row.scan_date) }}</td>
                <td class="actions-cell">
                  <button v-if="row.lat != 'N/A' || row.lng != 'N/A'" class="btn btn-sm btn-info"
                    @click="viewScanMap(row)"
                    style="margin-right: 5px; padding: 0; border: none; background: transparent;">
                    <img :src="scanMapIcon" alt="View Map" style="width: 34px; height: 24px;" />
                  </button>
                  <button v-if="row.file" class="btn btn-sm btn-primary" @click="openGambarModal(row.file)"
                    style="padding: 0; border: none; background: transparent;">
                    <img :src="openImageIcon" alt="Open" style="width: 34px; height: 24px;" />
                  </button>
                  <span v-else class="no-preview">-</span>
                </td>
              </tr>
              <tr v-if="!tableLoading && tableData.length === 0">
                <td colspan="9" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mt-3" v-if="!tableLoading && (tableData.length > 0 || maxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <label for="items-per-page"
                style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px;">View</label>
              <select id="items-per-page" v-model="limitPerPage" @change="onLimitChange"
                class="form-control form-control-sm" style="width: auto; display: inline-block; padding: 4px 8px;">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span class="items-per-page-text">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0;">
                Showing {{ (currentPage - 1) * limitPerPage + 1 }}-{{ currentPage * limitPerPage < total ? currentPage *
                  limitPerPage : total }} of {{ total > 0 ? total : '?' }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap;">
                  <li class="page-item" :class="{ disabled: currentPage <= 1 }"
                    @click.stop.prevent="changePage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage >= maxPage && !hasMoreData }"
                    @click.stop.prevent="changePage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Table End -->

    <!-- Modal Start -->
    <gambar-modal v-if="modal.gambar" :img="modal.gambarImg" @closeModal="modal.gambar = false"></gambar-modal>
    <scan-map-modal v-if="modal.map" :coordinate="modal.mapData" @closeModal="modal.map = false"></scan-map-modal>
    <!-- Modal End -->
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";
import customFilter from "@/components/filter/customFilter";

import gambarModal from "./children/gambarModal";
import scanMapModal from "./children/scanMapModal";

export default {
  metaInfo: {
    title: "Report - Consumer",
  },
  data() {
    return {
      tooltip: this.$store.state.tooltip.reports,
      modal: {
        gambar: false,
        gambarImg: null,
        map: false,
        mapData: null,
      },
      filter: {},
      // Table data
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      // Debounce timer
      fetchDataTimer: null,
      // Icons
      scanMapIcon: require("@/assets/CustomerActivities - Scan History Map Button.svg"),
      openImageIcon: require("@/assets/openImage.svg"),
    };
  },
  components: {
    customFilter,
    gambarModal,
    scanMapModal,
  },
  computed: {
    hasMoreData() {
      // If we got a full page of data, there's likely more
      return this.tableData.length === this.limitPerPage;
    },
  },
  mounted() {
    // Data will be fetched when filter changes
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.currentPage = 1; // Reset to first page
        this.fetchData();
      },
    },
  },
  methods: {
    changeFilter(filter) {
      let filters = {};

      for (const i in filter) {
        filters[i] = filter[i];
      }

      //Delete unnecessary filter for the table
      delete filters.filter;

      this.filter = filters;
    },
    async fetchData() {
      // Clear existing timer to debounce rapid calls
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }

      this.fetchDataTimer = setTimeout(() => {
        this.performFetchData();
      }, 300); // 300ms debounce
    },
    async performFetchData() {
      this.tableLoading = true;

      try {
        // Build filter object
        let queryParams = {
          pagination: true,
          limit: this.limitPerPage,
          page: this.currentPage,
          order: "DESC",
          by: "scan_date",
        };

        // Add filter parameters
        if (this.filter.start) {
          queryParams.start = this.filter.start;
        }
        if (this.filter.end) {
          queryParams.end = this.filter.end;
        }
        if (this.filter.variant) {
          queryParams.variant = this.filter.variant;
        }

        const url = `/api/reports/customer-report/table?${qs.stringify(queryParams, {
          skipNulls: true,
          arrayFormat: "comma",
        })}`;

        const resp = await this.$http.get(url);

        console.log('API Response:', resp.data);

        const rawData = resp.data.data || [];

        // Process data according to process_data logic
        let data = rawData;
        for (const i in data) {
          data[i].url = data[i].url ? data[i].url : data[i].scan_qrcode;
          data[i].variant = data[i].variant ? data[i].variant : 'N/A';
          data[i].volume = data[i].volume ? (Number.parseInt(data[i].volume)) / 1000 + ' Lt' : 'N/A';
          data[i].reason = data[i].reason ? data[i].reason : 'N/A';
          data[i].description = data[i].description ? data[i].description : 'N/A';
          data[i].lat = data[i].lat ? data[i].lat : 'N/A';
          data[i].lng = data[i].lng ? data[i].lng : 'N/A';
          data[i].scan_date = data[i].scan_date ? data[i].scan_date : 'N/A';
        }

        // Check for pagination meta in various possible locations
        const meta = resp.data.meta || resp.data.pagination || resp.data || {};

        console.log('Pagination Meta:', meta);

        // Process data
        this.tableData = data;

        // Handle pagination metadata - check multiple possible field names
        const currentPage = meta.currentPage || meta.current_page || meta.page || this.currentPage || 1;
        let total = meta.total || meta.totalItems || meta.total_count || meta.totalRecords || meta.count || 0;
        let lastPage = meta.lastPage || meta.last_page || meta.totalPages || meta.total_pages || meta.maxPage || 0;

        console.log('Parsed pagination:', { currentPage, total, lastPage, dataLength: this.tableData.length, limitPerPage: this.limitPerPage });

        // If total is 0 but we have data, we need to estimate
        // If we got a full page of data, there might be more pages
        if (total === 0) {
          if (this.tableData.length === this.limitPerPage) {
            // We got a full page, so there's likely more data
            // Set total to at least current page * limit, but we'll calculate lastPage differently
            total = this.currentPage * this.limitPerPage;
            // We'll calculate lastPage based on whether we can go to next page
            lastPage = this.currentPage + 1; // At least one more page exists
          } else if (this.tableData.length > 0) {
            // We got partial data, so this is likely the last page
            total = (this.currentPage - 1) * this.limitPerPage + this.tableData.length;
            lastPage = this.currentPage;
          } else {
            // No data
            total = 0;
            lastPage = 1;
          }
        } else if (total > 0) {
          // We have total, calculate lastPage if not provided
          if (!lastPage || lastPage === 0) {
            lastPage = Math.ceil(total / this.limitPerPage);
          }
        }

        // Ensure lastPage is at least 1
        lastPage = Math.max(1, lastPage);

        // If we got a full page and we're on the last calculated page, there might be more
        if (this.tableData.length === this.limitPerPage && this.currentPage >= lastPage) {
          lastPage = this.currentPage + 1;
        }

        console.log('Final pagination state:', { currentPage, total, lastPage });

        // Update pagination state
        this.$set(this, 'currentPage', Number.parseInt(currentPage));
        this.$set(this, 'maxPage', Number.parseInt(lastPage));
        this.$set(this, 'total', Number.parseInt(total));
      } catch (err) {
        console.log('Error fetching customer report data:', err);
        this.$set(this, 'tableData', []);
        this.$set(this, 'currentPage', 1);
        this.$set(this, 'maxPage', 1);
        this.$set(this, 'total', 0);
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.$set(this, 'currentPage', 1);
      this.fetchData();
    },
    changePage(opt) {
      if (this.tableLoading) {
        return;
      }

      let newPage = this.currentPage;

      if (opt === 'prev') {
        newPage = Math.max(1, this.currentPage - 1);
      } else if (opt === 'next') {
        // Allow going to next page if we have more data or if we're not at maxPage
        if (this.hasMoreData || this.currentPage < this.maxPage) {
          newPage = this.currentPage + 1;
        } else {
          return; // Can't go to next page
        }
      }

      if (newPage !== this.currentPage && newPage >= 1) {
        this.$set(this, 'currentPage', newPage);
        this.fetchData();
      }
    },
    viewScanMap(row) {
      // Convert lat/lng to numbers if they're valid
      const lat = row.lat === 'N/A' ? 0 : Number.parseFloat(row.lat);
      const lng = row.lng === 'N/A' ? 0 : Number.parseFloat(row.lng);

      this.modal.mapData = {
        lat: lat,
        lng: lng,
      };
      console.log(
        "%cReportCustomer2.vue viewScanMap",
        "color: #007acc;",
        JSON.stringify(this.modal.mapData)
      );
      this.modal.map = true;
    },
    openGambarModal(file) {
      this.modal.gambarImg = file.replaceAll('"', "");
      this.modal.gambar = true;
    },
    formatScanDate(value) {
      if (!value || value === 'N/A') {
        return 'N/A';
      }
      const parsed = moment(value);
      if (!parsed.isValid()) {
        return value;
      }
      return parsed.format('YYYY-MM-DD | hh:mm:ss');
    },
    truncateText(text, limit = 40) {
      if (text === null || text === undefined) {
        return 'N/A';
      }
      if (text === 'N/A') {
        return text;
      }
      const normalizedText = String(text);
      if (normalizedText.length <= limit) {
        return normalizedText;
      }
      return `${normalizedText.slice(0, limit).trimEnd()}...`;
    },
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  padding: 20px;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9D9D9D;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4B4B4B;
  text-align: left;
  vertical-align: middle;
  background-color: #FFFFFF !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.actions-cell {
  white-space: nowrap;
}

.actions-cell .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

/* Pagination Styles - Minimalist */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4B4B4B;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9D9D9D !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}

:deep(.popover-header) {
  background-color: #ffffff;
  border-bottom: none;
  font-weight: 600;
  font-size: 12px;
  color: #111111;
}

:deep(.popover-body) {
  background-color: #ffffff;
  font-weight: 400;
  font-size: 12px;
  color: #9d9d9d;
}

.items-per-page-text {
  margin-left: 8px;
  color: #a3a4a6;
  font-size: 14px;
}

.no-preview {
  color: #a3a4a6;
  font-size: 14px;
  display: inline-block;
  min-width: 34px;
  text-align: center;
}
</style>